import React from 'react';
import { Card, CardContent } from '@/components/ui';

export function ProjectStatistics() {
  const data = [
    { label: 'Đang thực hiện', count: 58, percent: 35.8, color: 'bg-blue-500' },
    { label: 'Hoàn thành', count: 72, percent: 44.4, color: 'bg-emerald-500' },
    { label: 'Tạm dừng', count: 18, percent: 11.1, color: 'bg-orange-400' },
    { label: 'Hủy', count: 6, percent: 3.7, color: 'bg-red-500' },
    { label: 'Chưa khởi tạo', count: 8, percent: 4.9, color: 'bg-slate-300' },
  ];

  return (
    <Card className="border-none shadow-sm h-full flex flex-col">
      <CardContent className="p-6 flex-1 flex flex-col">
        <h3 className="text-sm font-bold text-slate-800 mb-6">Thống kê dự án theo trạng thái</h3>
        
        <div className="flex items-center gap-8 flex-1">
          <div className="relative w-32 h-32 shrink-0">
            <svg className="w-full h-full" viewBox="0 0 36 36">
              <circle cx="18" cy="18" r="16" fill="none" className="stroke-slate-100" strokeWidth="4" />
              <circle cx="18" cy="18" r="16" fill="none" className="stroke-emerald-500" strokeWidth="4" strokeDasharray="44 100" strokeDashoffset="0" transform="rotate(-90 18 18)" strokeLinecap="round" />
              <circle cx="18" cy="18" r="16" fill="none" className="stroke-blue-500" strokeWidth="4" strokeDasharray="36 100" strokeDashoffset="-44" transform="rotate(-90 18 18)" strokeLinecap="round" />
              <circle cx="18" cy="18" r="16" fill="none" className="stroke-orange-400" strokeWidth="4" strokeDasharray="11 100" strokeDashoffset="-80" transform="rotate(-90 18 18)" strokeLinecap="round" />
            </svg>
            <div className="absolute inset-0 flex flex-col items-center justify-center">
              <span className="text-xl font-black text-slate-800 leading-none">162</span>
              <span className="text-[10px] font-bold text-slate-400 mt-1">Tổng dự án</span>
            </div>
          </div>

          <div className="flex-1 space-y-3">
            {data.map((item) => (
              <div key={item.label} className="flex justify-between items-center text-[10px] font-bold">
                <div className="flex items-center gap-2">
                  <div className={`w-2 h-2 rounded-full ${item.color}`} />
                  <span className="text-slate-500">{item.label}</span>
                </div>
                <span className="text-slate-800">{item.count} ({item.percent}%)</span>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-6 pt-4 border-t border-slate-50">
          <button className="text-[10px] font-bold text-blue-500 flex items-center gap-1 hover:underline">
            Xem chi tiết dự án <i className="ri-arrow-right-line" />
          </button>
        </div>
      </CardContent>
    </Card>
  );
}
